/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { InputTypeAhead, PrimaryButton, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";
import moment from "moment";

import { LogsContainerWrapper, LogsContentLeft, LogsContentRight, LogsContentRow, LogsContentWrapper, LogsHeaderWrapper } from "./styles";

const doesIncludeError = text => {
  if (!text) {
    return false;
  }
  const errorWords = ["error", "failed", "missing"];
  // eslint-disable-next-line no-restricted-syntax
  for (const word of errorWords) {
    if (text.toString().toLowerCase().includes(word)) {
      return true;
    }
  }

  return false;
};

const CalculationLogs = props => {
  const { selectedRgiIdForLogs, calculationLogs, areLogsLoading, getCalculationLogs, setDashboardSelections } = props;
  const [selectedLog, setSelectedLog] = useState(null);
  const [copied, setCopied] = useState(false);

  const onCopyToCB = async () => {
    if (!copied && selectedLog) {
      let contentText = `Calculated on: ${selectedLog.createdAt}\r\n`;
      contentText = `${contentText}Report Group Instance ID: ${selectedLog.reportGroupInstanceId}\r\n`;
      contentText = `${contentText}Report Group ID: ${selectedLog.reportGroupId}\r\n`;
      contentText = `${contentText}As of date: ${selectedLog.asOfDate}\r\n`;
      contentText = `${contentText}\r\nEvents:\r\n`;
      selectedLog.events.forEach((event, idx) => {
        contentText = `${contentText}${idx}. ${event}\r\n`;
      });

      try {
        await navigator.clipboard.writeText(contentText);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 1000);
      } catch (e) {
        setCopied(false);
      }
    }
  };

  useEffect(() => {
    if (selectedRgiIdForLogs) {
      getCalculationLogs({ reportGroupInstanceId: selectedRgiIdForLogs });
    }
  }, [selectedRgiIdForLogs]);

  useEffect(() => {
    if (calculationLogs && calculationLogs.length) {
      setSelectedLog(calculationLogs[0]);
    }
  }, [calculationLogs]);

  const onPeriodSelect = value => {
    setSelectedLog(value);
  };

  if (areLogsLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", paddingTop: "2em", width: "100%" }}>
        <CircularProgress size={40} style={{ color: "#005AA9" }} />
      </div>
    );
  }

  if (calculationLogs && selectedLog) {
    return (
      <LogsContainerWrapper>
        <LogsHeaderWrapper>
          <InputTypeAhead
            variant="filled"
            id="createdAt"
            name="createdAt"
            label="Calculation run time"
            options={calculationLogs}
            displayWith={option => option && moment.utc(option.createdAt).format("MM/DD/YYYY HH:mm:ss")}
            setValueWith={option => option && option}
            onChange={onPeriodSelect}
            value={selectedLog}
            style={{ width: "250px" }}
          />
          <SecondaryButton
            label="Go back"
            size={ButtonSizeOptions.sm}
            onClick={() => {
              setDashboardSelections({ selectedRgiIdForLogs: null });
            }}
          />
        </LogsHeaderWrapper>
        <LogsContentWrapper>
          <LogsContentRow>
            <LogsContentLeft>Report Group Instance ID:</LogsContentLeft>
            <LogsContentRight>{selectedLog.reportGroupInstanceId}</LogsContentRight>
          </LogsContentRow>
          <LogsContentRow>
            <LogsContentLeft>Report Group ID:</LogsContentLeft>
            <LogsContentRight>{selectedLog.reportGroupId}</LogsContentRight>
          </LogsContentRow>
          <LogsContentRow>
            <LogsContentLeft>As of Date:</LogsContentLeft>
            <LogsContentRight>{selectedLog.asOfDate}</LogsContentRight>
          </LogsContentRow>
          <LogsContentRow>
            <LogsContentLeft>Events:</LogsContentLeft>
            <LogsContentRight>
              {selectedLog.events &&
                selectedLog.events.map((event, idx) => (
                  <p key={idx} style={{ lineHeight: "1em", margin: 0, marginBottom: "0.3em", color: doesIncludeError(event) ? "#d86268" : "#685f63" }}>
                    {`${idx}. ${event}`}
                  </p>
                ))}
            </LogsContentRight>
          </LogsContentRow>
          <div style={{ display: "flex", justifyContent: "flex-end", position: "absolute", bottom: "10px", left: "10px" }}>
            <PrimaryButton
              label={copied ? "Copied!" : "Copy to clipboard"}
              style={{ backgroundColor: "#005AA9", fontSize: "11px", padding: "5px" }}
              size={ButtonSizeOptions.sm}
              onClick={onCopyToCB}
            />
          </div>
        </LogsContentWrapper>
      </LogsContainerWrapper>
    );
  }

  return null;
};

export default CalculationLogs;
